import { render } from "./ItemViewButtons.vue?vue&type=template&id=00983abc"
import script from "./ItemViewButtons.vue?vue&type=script&lang=js"
export * from "./ItemViewButtons.vue?vue&type=script&lang=js"

import "./ItemViewButtons.vue?vue&type=style&index=0&id=00983abc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__